import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import {
    parameterizablePasswordOrAKVtoSecretBase,
    parameterizableSecretBaseToModel
} from 'app/model/adapters/linkedservices/azure-key-vault.util';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { Model } from 'app/model/backendmodel';
import {
    ATTIO_APP_MODEL_VERSION,
    ATTIO_AUTHENTICATION_TYPE,
    ATTIO_RUNTIME_VERSION,
    AttioLinkedService
} from 'app/model/linkedservice/attio.linkedservice';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AttioLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            version: '*',
            sideBySideConnectorVersion: '*',
            typeProperties: {
                url: '*',
                authentication: '*',
                accessToken: 'secret'
            },
            parameters: '*'
        }
    }
})
export class AttioLinkedServiceAdapter extends LinkedServiceAdapter<AttioLinkedService> {
    protected supportFirstClassParameterExperience = true;

    protected modelConstructor(): new () => AttioLinkedService {
        return AttioLinkedService;
    }

    protected model(): IModel {
        return AttioLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(
        linkedService: AttioLinkedService,
        linkedServiceResource: Model.LinkedServiceResource
    ): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.AttioLinkedService;
        properties.type = Metamodel.modelFor(AttioLinkedService).name;
        properties.version = ATTIO_APP_MODEL_VERSION;
        properties.sideBySideConnectorVersion = ATTIO_RUNTIME_VERSION;
        properties.typeProperties = {
            url: ValueAdapter.toResource(linkedService, AttioLinkedService.URL),
            authentication: ATTIO_AUTHENTICATION_TYPE,
            accessToken: parameterizablePasswordOrAKVtoSecretBase(
                linkedService,
                AttioLinkedService.ACCESS_TOKEN,
                this.context
            )
        };
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(
        linkedServiceResource: Model.LinkedServiceResource,
        linkedService: AttioLinkedService
    ): Promise<AttioLinkedService> {
        const properties = linkedServiceResource.properties as Model.AttioLinkedService;
        linkedService.version = properties.version ?? ATTIO_APP_MODEL_VERSION;
        linkedService.sideBySideConnectorVersion =
            properties.sideBySideConnectorVersion ?? ATTIO_RUNTIME_VERSION;
        ValueAdapter.toModel(linkedService, AttioLinkedService.URL, properties.typeProperties.url);
        linkedService.authentication =
            properties.typeProperties.authentication ?? ATTIO_AUTHENTICATION_TYPE;
        parameterizableSecretBaseToModel(
            linkedService,
            AttioLinkedService.ACCESS_TOKEN,
            properties.typeProperties.accessToken,
            this.context
        );
        return linkedService;
    }
}
